import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import QRCode from 'qrcode';
// WiFi utility functions
const generateWiFiQR = async (ssid, password, security = 'WPA') => {
    const wifiString = `WIFI:T:${security};S:${ssid};P:${password};;`;
    try {
        return await QRCode.toDataURL(wifiString, {
            width: 120,
            margin: 1,
            color: {
                dark: '#2c3e50',
                light: '#ffffff'
            }
        });
    } catch (err) {
        console.error('QR Code generation failed:', err);
        return null;
    }
};
const wifiIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="800px" height="800px" viewBox="0 0 410 410" xml:space="preserve">
<g>
	<g>
		<g>
			<circle cx="205" cy="304.873" r="47.05"/>
			<path d="M205,153.887c-57.634,0-109.614,34.209-132.423,87.155c-5.607,13.018,0.399,28.114,13.415,33.722     c13.018,5.608,28.115-0.396,33.722-13.414c14.692-34.1,48.169-56.136,85.286-56.136s70.594,22.036,85.286,56.136     c4.182,9.707,13.641,15.517,23.581,15.517c3.389,0,6.834-0.674,10.142-2.103c13.019-5.606,19.022-20.704,13.416-33.722     C314.614,188.096,262.634,153.887,205,153.887z"/>
			<path d="M405.797,166.646C361.235,98.664,286.17,58.078,205,58.078S48.765,98.664,4.203,166.646     c-7.771,11.854-4.459,27.761,7.394,35.532c4.338,2.844,9.219,4.203,14.045,4.203c8.362,0,16.561-4.081,21.487-11.598     c35.044-53.461,94.06-85.38,157.871-85.38c63.811,0,122.827,31.918,157.871,85.379c7.77,11.853,23.678,15.166,35.533,7.395     C410.256,194.407,413.567,178.5,405.797,166.646z"/>
		</g>
	</g>
</g>
</svg>`;
const generateIndividualHandouts = async (wifiData) => {
    const printWindow = window.open('', '_blank');
    let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Wi-Fi Access Cards</title>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    * {
                        box-sizing: border-box;
                    }
                    body { 
                        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif; 
                        margin: 0; 
                        padding: 20px;
                        background: #f8f9fa;
                        line-height: 1.5;
                        color: #2c3e50;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                    }
                    .wifi-card { 
                        width: 380px;
                        height: 580px;
                        background: white;
                        margin: 20px auto;
                        padding: 30px;
                        border-radius: 16px;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                        page-break-after: always;
                        page-break-inside: avoid;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        border: 1px solid #e3e8ee;
                    }
                    .wifi-card:last-child { 
                        page-break-after: avoid; 
                    }
                    .wifi-icon {
                        text-align: center;
                        margin-bottom: 16px;
                    }
                    .wifi-icon svg {
                        width: 48px;
                        height: 36px;
                        color: #3498db;
                    }
                    .header-title {
                        text-align: center;
                        font-size: 18px;
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 32px;
                        letter-spacing: 0.5px;
                    }
                    .main-content {
                        display: flex;
                        gap: 24px;
                        flex-grow: 1;
                        min-height: 150px;
                    }
                    .connection-section {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        gap: 24px;
                    }
                    .qr-section {
                        width: 140px;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                    }
                    .network-info, .password-info {
                        margin-bottom: 0;
                        text-align: center;
                    }
                    .network-label, .password-label {
                        font-size: 14px;
                        font-weight: 600;
                        color: #7f8c8d;
                        margin-bottom: 6px;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .network-name {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        margin-bottom: 0;
                        border: none;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .password-value {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                        background: transparent;
                        padding: 0;
                        border-radius: 0;
                        letter-spacing: 0;
                        margin-bottom: 0;
                        border: none;
                        font-family: 'Inter', sans-serif;
                        word-break: break-all;
                        line-height: 1.4;
                    }
                    .qr-label {
                        font-size: 11px;
                        color: #95a5a6;
                        margin-bottom: 8px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        line-height: 1.3;
                    }
                    .qr-code {
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #ecf0f1;
                        display: block;
                    }
                    .footer-section {
                        margin-top: auto;
                        padding-top: 24px;
                        border-top: 1px solid #ecf0f1;
                    }
                    .terms-text {
                        font-size: 9px;
                        color: #95a5a6;
                        text-align: center;
                        line-height: 1.4;
                        margin-bottom: 12px;
                    }
                    .unit-info {
                        font-size: 10px;
                        color: #7f8c8d;
                        text-align: center;
                        margin-bottom: 16px;
                        font-weight: 500;
                        text-transform: none;
                        letter-spacing: 0;
                    }
                    .brand-section {
                        text-align: center;
                    }
                    .brand-logo {
                        font-size: 14px;
                        font-weight: 700;
                        color: #3498db;
                        margin-bottom: 2px;
                        text-transform: none;
                        letter-spacing: 0.5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                    }
                    .brand-subtitle {
                        font-size: 10px;
                        font-weight: 400;
                        color: #3498db;
                        margin-bottom: 8px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    .copyright {
                        font-size: 8px;
                        color: #bdc3c7;
                        text-align: center;
                    }
                    @media print {
                        body { 
                            background: white !important; 
                            padding: 0 !important; 
                        }
                        .wifi-card { 
                            box-shadow: none !important; 
                            margin: 0 auto !important;
                            page-break-inside: avoid !important;
                            border: 1px solid #e3e8ee !important;
                        }
                        @page {
                            margin: 0.5in;
                            size: auto;
                        }
                    }
                    @media screen and (max-width: 480px) {
                        .wifi-card {
                            width: 90%;
                            margin: 10px auto;
                            padding: 20px;
                        }
                        .main-content {
                            flex-direction: column;
                            gap: 16px;
                        }
                        .qr-section {
                            width: 100%;
                        }
                        .header-title {
                            font-size: 16px;
                        }
                    }
                </style>
            </head>
            <body>
        `;
    // Generate QR codes for all units if needed
    const unitsWithQR = await Promise.all(
        wifiData.units?.map(async (unit) => {
            const qrDataURL = await generateWiFiQR(unit.ssid, unit.psk, unit.security);
            return { ...unit, qrCode: qrDataURL };
        }) || []
    );
    unitsWithQR.forEach((unit, index) => {
        htmlContent += `
            <div class="wifi-card">
                <div class="wifi-icon">${wifiIconSVG}</div>
                <div class="header-title">CONNECT TO WI-FI</div>
                <div class="main-content">
                    <div class="connection-section">
                        <div class="network-info">
                            <div class="network-label">Network</div>
                            <div class="network-name">${unit.ssid}</div>
                        </div>
                        <div class="password-info">
                            <div class="password-label">Password</div>
                            <div class="password-value">${unit.psk}</div>
                        </div>
                    </div>
                    ${unit.qrCode ? `
                        <div class="qr-section">
                            <div class="qr-label">or scan here to connect</div>
                            <img src="${unit.qrCode}" alt="WiFi QR Code" class="qr-code" />
                        </div>
                    ` : ''}
                </div>
                <div class="footer-section">
                    <div class="terms-text">
                        By connecting you agree to the Wi-Fi Terms of Service found on<br>
                        ${sessionStorage.getItem("PrivacyPolicyURL") || "your property management website"}<br>
                        For questions or to request a printout of terms, please contact your<br>
                        property management
                    </div>
                    <div class="unit-info">
                        Building ${unit.building} Floor ${unit.floor} Unit ${unit.unitID}
                    </div>
                    <div class="brand-section">
                        <div class="brand-logo">
                            <img src="${sessionStorage.getItem("logoURL") || sessionStorage.getItem("logo") || "logo.png"}" alt="Logo" style="height: 20px; margin-right: 6px;" />
                            ${sessionStorage.getItem("clientName") || "GROOVE"}
                        </div>
                    </div>
                    <div class="copyright">©2025 ${sessionStorage.getItem("clientName") || "GROOVE"} Technology Solutions. All rights reserved.</div>
                </div>
            </div>
        `;
    });
    htmlContent += `</body></html>`;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    // Auto-print after content loads
    setTimeout(() => {
        printWindow.print();
    }, 1000);
};
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];
    if (props.subscriberKeys !== undefined) {
        for (const key of Object.keys(props.subscriberKeys)) {
            for (const keynetwork of Object.keys(props.subscriberKeys[key])) {
             console.log(props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"])
             
             // Iterate through each VenueUnitPolicy
             for(const venueUnitPolicyKey of Object.keys(props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"] || {})){
                if (
                    props.subscriberKeys[key][keynetwork]["KeyTag"] !==
                    undefined && props.subscriberKeys[key]!== "ssid" &&
                    props.subscriberKeys[key] !== "DisplayOrder" && 
                    props.subscriberKeys[key][keynetwork]["currentState"]  !== "Inactive" &&
                    props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey] !== undefined
                    // props.subscriberKeys[key][keynetwork][venueUnitPolicy]["UnitID_internal"]  === sessionStorage.getItem("unitID_internalSubscriber")
                    // props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey]["UnitID_internal"]=== sessionStorage.getItem("unitID_internalSubscriber")
                ) {
                    userAttributes.push({
                        id: i,
                        keynetwork: keynetwork,
                        key: key,
                        ssid: props.subscriberKeys[key]["ssid"],
                        keytag: props.subscriberKeys[key][keynetwork]["KeyTag"],
                        psk: props.subscriberKeys[key][keynetwork]["psk"],
                        subscriberKeys: props.subscriberKeys[key],
                        dateStart: Intl.DateTimeFormat("en-CA", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "numeric",
                            minute: "numeric",
                        }).format(
                            new Date(
                                props.subscriberKeys[key][keynetwork][
                                    "dateAddedUTC.ISO8601"
                                ]
                            )
                        ),
                        venueName: props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey]["VenueName"],
                        unitName: props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey]["UnitID"],
                        buildingName: props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey]["UnitBuilding"],
                        floorName: props.subscriberKeys[key][keynetwork]["VenueUnitPolicies"][venueUnitPolicyKey]["UnitFloor"],
                        venueUnitPolicyKey: venueUnitPolicyKey, // Add this to track which policy this row represents
                    });
                    i = i + 1;
                }
            }
        }
       }
    }
    columns = [
        {
            headerName: "Network Name",
            field: "ssid",
            minWidth: 150,
        },
        {
            headerName: "Venue",
            field: "venueName",
            minWidth: 150,
        },
        {
            headerName: "Unit",
            field: "unitName",
            minWidth: 150,
        },
        {
            headerName: "Building",
            field: "buildingName",
            minWidth: 150,
        },
        {
            headerName: "Floor",
            field: "floorName",
            minWidth: 150,
        },
        {
            headerName: "Keytag",
            field: "keytag",
            minWidth: 200,
        },
        {
            headerName: "Action",
            field: "receipt",
            minWidth: 550,
            renderCell: (params) => (
                <div>
                    <Button
                        onClick={() =>
                          props.toggleShowWifiPassword(
                              params.row.key,
                              params.row.keynetwork
                          )
                        }
                        rel="noreferrer"
                    >
                        Show Wi-Fi Password
                    </Button>
                    <Button
                    size="small"
                        variant="outlined"
                        onClick={() =>
                          props.openChangeWifiPassword(
                              params.row.key,
                              params.row.keynetwork,
                              params.row.ssid,
                              params.row.keytag,
                              params.row.subscriberKeys
                          )
                        }
                        rel="noreferrer"
                    >
                        Change Wi-Fi Password
                    </Button>
                    <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                                // Create WiFi data using the row data directly
                                                const wifiData = {
                                                    units: [{
                                                        unitID: params.row.unitName || params.row.key,
                                                        building: params.row.buildingName || "DEFAULT",
                                                        floor: params.row.floorName || "DEFAULT", 
                                                        ssid: params.row.ssid,
                                                        psk: params.row.psk,
                                                        security: "WPA2" // Assuming WPA2, adjust as needed
                                                    }]
                                                };
                                                // Call the generate function directly
                                                generateIndividualHandouts(wifiData);
                                            }}
                                        >
                                            Generate WiFi Handout
                                        </Button>
                </div>
            ),
        },
    ];
    rows = userAttributes;
    return (
        <div style={{ height: 300, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 50 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
    );
}
